import { htmlDecodeMaster } from '../../common/functions';

function HsHtmlRenderer(props) {
  return props.content ? htmlDecodeMaster(props.content) : '';
}

export default HsHtmlRenderer;
